/* eslint-disable @typescript-eslint/no-unused-vars */
import { BADQUERY } from 'dns'
import React, { useContext, useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom'

import { sitePath } from '../../../assets/ts/api/api'
import { mpfRListsHttp } from '../../../assets/ts/api/mpf-r-lists-http'
import { DueOut } from '../../../assets/ts/data/dueout/dueout'
import { UploadFiles, getMetadata } from '../../../assets/ts/data/files/files'
import { Inquiry, InquiryFiles, LIST_NAME } from '../../../assets/ts/data/inquiry/inquiry'
import { formatUTCDateToLocal } from '../../../assets/ts/date-and-time/date-and-time'
import { callFiles, openFile } from '../../../assets/ts/files/files'
import { defaultToEmptyString, twoDigits } from '../../../assets/ts/formatting/formatting'
import { formatBody, sendEmail, sendNotification } from '../../../assets/ts/general/general'
import {
  addToPIIAuditTrail,
  areChangesStored,
  getPIIScanInfo,
  loadPII,
} from '../../../assets/ts/pii/pii'
import Accordions from '../../../components/accordions/accordions'
import Alert from '../../../components/alert/alert'
import DialogBox from '../../../components/alert/dialog-box'
import ActionButtons from '../../../components/buttons/action-buttons'
import Buttons from '../../../components/buttons/buttons'
import FileUpload from '../../../components/file-upload/file-upload'
import PIIPopup from '../../../components/page-overlay/pii-popup'
import { RoleContext } from '../../../store/role-context-provider'
import { UserContext } from '../../../store/user-context-provider'
import { NORESULT } from '../../../utils/constants/rhybus-config'
import InputCheckbox from '../../../utils/controls/input-checkbox'

const initialValues = ['customerAddFiles', 'mpfAddFiles', 'teamMembersAddFiles']
let elementHeightValue: number
let offsetLeftValue: number
let offsetTopValue: number
let offsetWidthValue: number
let popupTop: number
let xPositionValue: any
interface FilesProps {
  ItemGUID: string
  checkAll: boolean
  currentInquiry: DueOut | Inquiry
  filesProps: any
  getSelectedFiles: () => void
  hideButton?: boolean
  isInquiry: boolean
  reverseCheck: boolean
  role: any
  setCheckAll: () => void
}
const AccordionFiles = (props: FilesProps) => {
  const LIST = props.isInquiry ? LIST_NAME : 'DueOutList'

  const { multiplePopup, setMultiplePopup } = useContext(UserContext)
  const addfiles = useRef(null)
  const popupbtnRef = useRef(null)
  const popupBtnRef = useRef(null)

  const [checkAllFiles, setCheckAllFiles] = useState(false)
  const [displayAlert, setDisplayAlert] = useState(false)
  const [displayPII, setDisplayPII] = useState(false)
  const [fileError, setFileError] = useState(false)
  const [noFileError, setNoFileError] = useState(false)
  const [replaceFile, setReplaceFile] = useState(false)
  const [proceed, setProceed] = useState(false)

  const [popupHeight, setPopupHeight] = useState<number>()
  const [xPositionValueUpdate, setXPositionValueUpdate] = useState()

  const [addFolder, setAddFolder] = useState('')
  const [alertMessage, setAlertMessage] = useState('')
  const [folderName, setFolderName] = useState('')

  const [allFiles, setAllFiles] = useState([])
  const [appFiles, setAppFiles] = useState<InquiryFiles[]>([])
  const [checkedArr, setCheckedArr] = useState<string[]>([])
  const [customerFiles, setCustomerFiles] = useState<InquiryFiles[]>([])
  const [files, setFiles] = useState([]) // PII -> uploadedFilesarr
  const [modifyFiles, setModifyFiles] = useState<InquiryFiles[]>([])
  const [teamMemberFiles, setTeamMemberFiles] = useState<InquiryFiles[]>([])

  const [actionBtnShowHide, setActionBtnShowHide] = useState({
    customerAddFiles: false,
    mpfAddFiles: false,
    teamMembersAddFiles: false,
  })
  const [piiScan, setPIIScan] = useState({}) //PII
  const [showActionPopups, setShowActionPopups] = useState({
    customerAddFiles: false,
    mpfAddFiles: false,
    teamMembersAddFiles: false,
  })

  const userContext = useContext(UserContext)
  const currentUser = userContext?.me?.userId

  const showHide: any = { ...actionBtnShowHide }

  function popupCloseOpenFunctionality(
    type: any,
    value: number,
    top: number,
    xPosition: number,
    left: number,
    elementHeight: number,
    offsetWidth: number
  ) {
    popupTop = top
    xPositionValue = xPosition
    offsetLeftValue = left
    offsetTopValue = top
    offsetWidthValue = offsetWidth
    initialValues.forEach((element) => {
      showHide[element] = false
    })
    setActionBtnShowHide(showHide)
    if (type === multiplePopup) {
      setMultiplePopup()
    } else if (type) {
      setMultiplePopup(type)
    }
    setFiles([])
    setAddFolder(type)
    setFileError(false)
  }
  function showHideCheck(folderName: string): boolean {
    switch (folderName) {
      case 'MPF/CSS':
        return appFiles?.length > 0
      case 'Customer':
        return customerFiles?.length > 0
      case 'Team Members':
        return teamMemberFiles?.length > 0
      default:
        return false
    }
  }
  const addFilePopup = (e: Event) => {
    e.stopPropagation() // Prevent the event from bubbling up to parent elements
    e.preventDefault() // Prevent the default behavior (like form submission)
    // Your code logic here
  }
  const handleCheck = (isChecked: boolean, fileName?: string, folder?: string) => {
    let checkedFolders = []
    checkedFolders = checkedArr
    if (isChecked) {
      checkedFolders.push(folder)
    } else {
      checkedFolders = checkedFolders.filter(function (file) {
        return file !== folder
      })
    }
    setCheckedArr(checkedFolders)
    let checked = []
    checked =
      fileName === ''
        ? isChecked // check all
          ? [...allFiles.filter((file: File) => checkedFolders.includes(file.DocumentTitle))]
          : [...allFiles.filter((file: File) => checkedFolders.includes(file.DocumentTitle))]
        : isChecked // check individual
        ? modifyFiles?.length > 0
          ? [
              ...checked,
              ...modifyFiles,
              ...allFiles.filter((file: File) => file.fileName === fileName),
            ]
          : [...checked, ...allFiles.filter((file: File) => file.fileName === fileName)]
        : modifyFiles.filter(function (file: InquiryFiles) {
            return file.fileName !== fileName
          })
    if (!isChecked && checkAllFiles) {
      setCheckAllFiles(false)
    }
    setModifyFiles(checked)
  }
  const returnUserName = (file): string => {
    for (const [key, value] of file) {
      if (key === 'createdby') {
        return value
      }
    }
    console.error(`Check backend for missing Submitter.`)
    return ''
  }

  const deleteFiles = async (event: Event, foldername: string) => {
    event?.stopPropagation()
    if (!modifyFiles.length) {
      setAlertMessage('Please select at least one document to delete.')
      setDisplayAlert(true)
    } else {
      setAlertMessage('Are you sure, you want to delete the selected item?')
      setDisplayAlert(true)
      setFolderName(foldername)
    }
  }

  const handleEmails = async (isInquiry, action, fileData) => {
    const userDetails = await mpfRListsHttp().me()
    const userId = userDetails.userId
    const detailView = isInquiry ? 'detailview' : 'dueoutdetailview'
    const dataGUID = isInquiry
      ? props?.currentInquiry?.InquiryGUID
      : props?.currentInquiry?.DueOutGUID
    const navURL = sitePath + `/${detailView}/${dataGUID}`
    const dataId = isInquiry ? props?.currentInquiry?.InquiryID : props?.currentInquiry?.DueOutID
    let bodyText = `File(s):`

    fileData.forEach((file) => (bodyText += `<br/>${file.fileName || file.name}`))

    const emailBodyData = {
      ...props?.currentInquiry,
      bodyText: bodyText,
    }

    const body = formatBody(`Document`, emailBodyData, navURL)
    const to = props?.currentInquiry?.Customer?.userID

    const emailObjData = {
      ...props?.currentInquiry,
      Action: 'Add Document',
      ItemGUID: dataGUID,
      ItemID: dataId,
      Title: props?.currentInquiry?.Subject,
    }

    const emails: Promise<any>[] = []

    if (to && to !== userId) {
      emails.push(
        sendEmail({
          bcc: '',
          body: body,
          bodySurvey: '',
          cc: '',
          data: emailObjData,
          isDiscussion: false,
          isSurvey: false,
          loginuserId: userId,
          navURL: navURL,
          subject: `${isInquiry ? 'Inquiry' : 'Due Out'} '${dataId}' - File(s) ${
            action === 'Added' ? 'uploaded' : 'deleted'
          }`,
          to: to,
        })
      )
    }
    if (props?.currentInquiry?.TeamMembers && props?.currentInquiry?.TeamMembers.length > 0) {
      const teamMembers = props?.currentInquiry?.TeamMembers
      for (const teamMember of teamMembers) {
        if (teamMember.userID !== userId) {
          emails.push(
            sendEmail({
              bcc: '',
              body: body,
              bodySurvey: '',
              cc: '',
              data: emailObjData,
              isDiscussion: false,
              isSurvey: false,
              loginuserId: userId,
              navURL: navURL,
              subject: `${isInquiry ? 'Inquiry' : 'Due Out'} '${dataId}' - File(s) ${
                action === 'Added' ? 'uploaded' : 'deleted'
              }`,
              to: teamMember.userID,
            })
          )
        }
      }
    }

    await Promise.all(emails)
  }
  useEffect(() => {
    const element = document.getElementsByClassName(`${addFolder + '-files-div'}`)
    if (element) {
      setTimeout(() => {
        element?.[0]?.scrollIntoView({ behavior: 'smooth', block: 'end' })
      }, 100)
    }
  }, [multiplePopup, addFolder])

  const isTeamMember = (teamMembers, currUserId): boolean => {
    return teamMembers?.some((member) => {
      return member.userID === currUserId
    })
  }

  const onClickAlert = (button: string) =>{
    if (button === 'Ok') {
      setProceed(true)
      setAlertMessage('')
      setDisplayAlert(false)
    } else {
      setAlertMessage('')
      setDisplayAlert(false)
    }
  }

  //<------------------------ JSX ------------------------>

  const folder = (files: InquiryFiles[]) => {
    return files?.length > 0 ? (
      files.map((file: InquiryFiles) => (
        <div className='d-flex align-items-start ms-3 border-bottom2 mb-2 pb-2' key={file.eKey}>
          <InputCheckbox
            className='h-auto'
            formClassName='form-horizontal pt-1 pe-1 font-0'
            inputProps={{
              checked:
                Array.from(new Set(modifyFiles.map((v: InquiryFiles) => v.fileName)))?.includes(
                  file.fileName
                ) || checkAllFiles,
              id: 'customer ',
              label: 'Customer ',
              name: 'Input Check',
              type: 'checkbox',
            }}
            onClick={(e: Event) => handleCheck(e.target.checked, file.fileName)}
          />
          <div aria-live='polite' tabIndex={0}>
            <a
              className='p-0 text-break poppins-medium color-primary font-11'
              href={file?.ServerRelativeUrl}
              onClick={() => callFiles(file, files, props?.currentInquiry?.eKey, LIST_NAME)}
              title={file.fileName}
            >
              {defaultToEmptyString(file.fileName)}
            </a>
            <p className='subtitle-color1 font-12 sourcesanspro'>
              Submitted: {defaultToEmptyString(formatUTCDateToLocal(file?.createdOn, 'Date'))}
            </p>
            <p className='subtitle-color1 font-12 sourcesanspro'>
              Submitted By: {defaultToEmptyString(returnUserName(file?.metadata))}
            </p>
          </div>
        </div>
      ))
    ) : (
      <div
        aria-label='There are no results to display'
        className=' subtitle-color2 montserratregular font-12 text-center py-2 min-h-200 d-flex align-items-center justify-content-around'
        tabIndex={0}
      >
        {NORESULT}
      </div>
    )
  }

  const accordionItems = [
    {
      Id: 1,
      content: <>{folder(customerFiles)}</>,
      count: twoDigits(customerFiles?.length),
      extras: (
        <InputCheckbox
          className='h-auto'
          formClassName='form-horizontal font-0'
          inputProps={{
            checked:
              (modifyFiles?.filter((i: InquiryFiles) => i?.DocumentTitle === 'Customer')?.length ===
                customerFiles?.length &&
                customerFiles?.length > 0) ||
              checkAllFiles,
            disabled: customerFiles?.length === 0,
            id: 'all',
            label: 'All',
            name: 'Input Check',
            type: 'checkbox',
          }}
          onClick={(e: Event) => {
            e.stopPropagation()
            handleCheck(e.target.checked, '', 'Customer')
          }}
        />
      ),
      extras1:
        props?.currentInquiry?.Customer?.userID === currentUser ||
        (props?.currentInquiry?.ItemCreatedBy.userID === currentUser && props.role === 'Customer')
          ?
            extraHTML
          : () => {
              ('')
            },
      hideDeleteButton : customerFiles?.length === 0 ,
      is_active: 'true',
      isExtra: true,
      title: 'Customer',
    },
    {
      Id: 2,
      content: <>{folder(appFiles)}</>,
      count: twoDigits(appFiles?.length),
      extras: (
        <InputCheckbox
          className='h-auto'
          formClassName='form-horizontal font-0'
          inputProps={{
            checked:
              (modifyFiles?.filter((i: InquiryFiles) => i?.DocumentTitle === 'MPF/CSS')?.length ===
                appFiles?.length &&
                appFiles?.length > 0) ||
              checkAllFiles,
            disabled: appFiles?.length === 0,
            id: 'all',
            label: 'All',
            name: 'Input Check',
            type: 'checkbox',
          }}
          onClick={(e: Event) => {
            e.stopPropagation()
            handleCheck(e.target.checked, '', 'MPF/CSS')
          }}
        />
      ),
      extras1:
      props.role !== 'Customer' &&
        //This condition may need to be readded based on requirement
        //&& props?.currentInquiry?.ItemCreatedBy?.userID !== currentUser
        !isTeamMember(props?.currentInquiry?.TeamMembers, currentUser)
          ? extraHTML
          : () => {
              ('')
            },
      hideDeleteButton : appFiles?.length === 0 ,
      is_active: 'false',
      isExtra: true,
      title: 'MPF/CSS',
    },
    {
      Id: 3,
      content: <>{folder(teamMemberFiles)}</>,
      count: twoDigits(teamMemberFiles?.length),
      extras: (
        <InputCheckbox
          className='h-auto'
          formClassName='form-horizontal font-0'
          inputProps={{
            checked:
              (modifyFiles?.filter((i: InquiryFiles) => i?.DocumentTitle === 'Team Members')
                ?.length === teamMemberFiles?.length &&
                teamMemberFiles?.length > 0) ||
              checkAllFiles,
            disabled: teamMemberFiles?.length === 0,
            id: 'all',
            label: 'All',
            name: 'Input Check',
            type: 'checkbox',
          }}
          onClick={(e: Event) => {
            e.stopPropagation()
            handleCheck(e.target.checked, '', 'Team Members')
          }}
        />
      ),
      extras1: isTeamMember(props?.currentInquiry?.TeamMembers, currentUser)
        ? extraHTML
        : () => {
            ('')
          },
      hideDeleteButton : teamMemberFiles?.length === 0 ,
      is_active: 'false',
      isExtra: true,
      title: 'Team Members',
    },
  ]

  function extraHTML(folderName: string ,hideDeleteButton: boolean  ) {
    return (
      <>
        {displayAlert && (
          <DialogBox
            btn1iconclassNmae='icon-checked font-12 pe-1'
            btn2iconclassNmae='icon-close color-primary font-10 pe-1'
            handleRouteNo={() => {
              setAlertMessage('')
              setDisplayAlert(false)
            }}
            handleRouteYes={() => {
              setProceed(true)
              setAlertMessage('')
              setDisplayAlert(false)
            }}
             message={alertMessage}
             primaryText={'Ok'}
            secondaryText={'Cancel'}
          />
        //   <Alert
        //   btn1className='btn-border-radius-3 px-2 btn-primary whitetext poppins-medium font-12 text-uppercase btn-xs'
        //   btn1iconclassNmae='icon-rb-checked  font-12 pe-1'
        //   btn2className='btn-border-radius-3 px-2 btn-border-1 darktext poppins-medium font-12 text-uppercase btn-xs'
        //   btn2iconclassNmae='icon-rb-close  font-12 pe-1'
        //   cancel='Cancel'
        //   className='alert-info'
        //   message={alertMessage}
        //   onClick={onClickAlert}
        //   yes='Ok'
        // />
        )}
        {!props.hideButton && (
          <>
            { !hideDeleteButton && <Buttons
              aria-label='Delete'
              className='btn-sm font-0 btn-border color-primary uppercase text-nowrap border-radius3 mx-1'
              icon='icon-trashbin font-10 me-xxl-1 p-0'
              label='Delete'
              onClick={(e: Event) => {
                e?.preventDefault()
                deleteFiles(e, folderName)
              }}
              type='button'
            />}
            <ActionButtons
              className={
                multiplePopup === addFolder && folderName === addFolder
                  ? 'popup-arrow btn text-nowrap btn-border btn btn-sm font-0 font-xxl-14 color-primary btn-border-radius3 p-relative ms-auto sourcesansprosemibold '
                  : 'btn text-nowrap btn-border btn btn-sm font-0 font-xxl-14 color-primary btn-border-radius3 p-relative ms-auto sourcesansprosemibold '
              }
              icon='icon-add color-primary font-10 me-xxl-1 p-0'
              id={folderName}
              isAccordionToggle={true}
              isClick='addfiles'
              label='Add'
              name='Add'
              popupCloseOpenFunctionality={popupCloseOpenFunctionality}
              ref={addfiles}
              showHide={showActionPopups.addfiles}
              type='button'
            />
          </>
        )}
        <div
          className='popup popup-sm pointer-events-none'
          onClick={(e) => addFilePopup(e)}
          ref={popupbtnRef}
          style={{
            display: multiplePopup === addFolder && folderName === addFolder ? '' : 'none',
            maxHeight: popupHeight,
            overflow: 'auto',
            position: 'absolute',
            right: '0px',
            top: popupTop + 8,
          }}
        >
          <div className='pt-2'>
            <FileUpload
              duplicateFileNames={allFiles?.map((file) => {
                return file.fileName
              })}
              error={fileError}
              fileError={fileError}
              filesProps={{ files, setFiles }}
              hint='Upload the files which are in the .png, .jpeg, .xlsx, .txt .docx, .pdf files and special characters will not be used in the document names. Maximum size for file is 25 MB. Limit is up to 10 files per screen'
              hintClassName='color-primary font-12'
              info='Attach File(s)'
              infoClassName='tool-tip tooltip-right font-12 sourcesanspro'
              infoIcon='icon-info'
              isInfo
              isMandatory={true}
              isVisible={Boolean(multiplePopup)}
              label='Add file (s)'
              noteClassName='color-primary ps-2'
              replaceFileProps={{ replaceFile, setReplaceFile }}
              setFileError={setFileError}
            />
          </div>
          <div className='row'>
            <div className='col-md-12 col-xs-12'>
              <div className='pii-compliance-validation' id='AnnouncementsValidationSection'>
                {displayPII && <PIIPopup piiScan={piiScan} setPIIScan={setPIIScan} />}
              </div>
            </div>
          </div>
          <div className={`pt-2 d-flex gap-2 pointer-events-all ${folderName + '-files-div'}`}>
            <Buttons
              aria-label='Ok'
              className='btn btn btn-sm btn-primary whitetext font-11 border-radius ms-auto text-uppercase poppins-semibold '
              icon='icon-checked font-10 me-1'
              label='Ok'
              onClick={(event) => {
                event?.preventDefault()
                validateFiles(event, folderName, replaceFile)
              }}
              type='button'
            />
            <ActionButtons
              className='btn btn-border1 title-color3 btn-sm font-11 border-radius text-uppercase poppins-semibold'
              icon='icon-close font-9 me-1 color-primary'
              id={folderName}
              isAccordionToggle={true}
              isClick='addfiles'
              label='Cancel'
              name='Cancel'
              onClick={() => setFiles([])}
              popupCloseOpenFunctionality={popupCloseOpenFunctionality}
              ref={addfiles}
              showHide={showActionPopups.addfiles}
              type='button'
            />
          </div>
        </div>
      </>
    )
  }

  const getFiles = async (isInquiry: boolean): Promise<void> => {
    let allFiles: InquiryFiles[] = []
    const metaDataList = await mpfRListsHttp().getList(LIST)

    const listBlobs = await metaDataList.blobs().list(props?.currentInquiry?.eKey)

    const blobMapData: any = new Map(listBlobs.map((obj) => [obj]))

    allFiles = [...blobMapData.keys()]
    const appFiles = []
    const CustomerFiles = []
    const TeamMemberFiles = []
    allFiles.forEach((file) => {
      if (file.folderName === '/MPF/CSS') {
        file.DocumentTitle = 'MPF/CSS'
        appFiles.push(file)
      } else if (file?.folderName === '/Customer' || file?.folderName === '/InquiryForm') {
        file.DocumentTitle = 'Customer'
        CustomerFiles.push(file)
      } else if (file?.folderName === '/Team Members') {
        file.DocumentTitle = 'Team Members'
        TeamMemberFiles.push(file)
      }
    })
    setAppFiles(appFiles)
    setCustomerFiles(CustomerFiles)
    setTeamMemberFiles(TeamMemberFiles)
    setAllFiles([...appFiles, ...CustomerFiles, ...TeamMemberFiles])
  }
  const callFiles = (item, fileslist, itemGUID, listName) => {
    const fileDetails = fileslist?.filter((comment) => {
      return comment.fileName === item.fileName
    })
    const file = fileDetails[0]
    openFile(file, itemGUID, listName)
  }
  const listAttachments = async (
    listName: string,
    itemKey: string,
    files: File[],
    folderName: string,
    replaceFile: boolean
  ): Promise<void> => {
    const list = await mpfRListsHttp().getList(listName)
    const blobFolder = '/' + folderName
    const userDetails = await mpfRListsHttp().me()
    const firstName = userDetails.firstName
    const lastName = userDetails.lastName
    const fullName = `${firstName} ${lastName}`
    let fileNames = ''
    for (const currFile of files) {
      const oldFile = allFiles?.filter((file) => {
        return file.etag === file.etag
      })
      const etag = replaceFile ? oldFile[0]?.eTag : ''

      const mData = getMetadata(currFile, fullName)
      fileNames = fileNames === '' ? currFile.name : fileNames + `, ${currFile.name}`
      UploadFiles(list, listName, itemKey, mData, etag, currFile, blobFolder).then(async () => {
        getFiles(props?.isInquiry)
        setModifyFiles([])
        setReplaceFile(false)
      })
    }
    await handleEmails(props.isInquiry, 'Added', files)
    await sendNotification(
      'DOCUMENT_ADD',
      {
        ...props?.currentInquiry,
        DocName: fileNames,
      },
      userDetails,
      props?.role?.replace('[SECTION_NAME]', '').trim() || '',
      !props?.isInquiry
    )
  }

  async function validateFiles(e, folder: string, replaceFile: boolean): Promise<void> {
    if (files?.length === 0 || files?.length > 10) {
      // setFiles({ ...files.slice(0, 10) })
      setFileError(true)
    }
    if (files?.length && files?.length <= 10) {
      const uploads = {
        FileArray: Object.values(files),
      }

      if (!fileError) {
        getPIIScanInfo(uploads, piiScan).then(function (uploadData) {
          if (uploadData.canSubmit === true) {
            handleUploadingPII(folder, replaceFile)
          } else {
            if (uploadData.canSubmit) {
              handleUploadingPII(folder, replaceFile)
            } else {
              setDisplayPII(true)
              setPIIScan(uploadData.piiScanResult)
            }
          }
        })
      }
    }
  }
  function handleUploadingPII(folder: string, replaceFile: boolean): void {
    if (files?.length > 0) {
      const promises = []

      listAttachments(LIST, props.currentInquiry.eKey, files, folder, replaceFile)
      if (piiScan && Object.keys(piiScan).length > 0) {
        addToPIIAuditTrail(
          'CreateInquiry',
          props.ItemGUID,
          piiScan,
          props?.currentInquiry?.InquiryID
        )
      }
      Promise.all(promises).then(function () {
        setMultiplePopup(undefined)
        setPIIScan({})
        getFiles(props?.currentInquiry)
      })
    } else {
      setFileError(true)
    }
  }
  useEffect(() => {
    if (!proceed) return

    const processDeletion = async () => {
      const userDetails = await mpfRListsHttp().me()
      const filesDel = modifyFiles.filter((file) => file.DocumentTitle === folderName)
      const listname = await mpfRListsHttp().getList(LIST)
      let fileNames = ''

      for (const element of filesDel) {
        const deletedEtag = element.eTag
        fileNames = fileNames === '' ? element.fileName : `${fileNames}, ${element.fileName}`
        await listname
          .blobs()
          .delete(props?.currentInquiry?.eKey, element.fileName, element.folderName, deletedEtag)
          .then(async () => {
            getFiles(props.isInquiry)
          })
      }

      await handleEmails(props.isInquiry, 'Delete', filesDel)
      await sendNotification(
        'DOCUMENT_DELETE',
        {
          ...props?.currentInquiry,
          DocName: fileNames,
        },
        userDetails,
        props?.role?.replace('[SECTION_NAME]', '').trim() || '',
        !props?.isInquiry
      )
      setAlertMessage('')
      setDisplayAlert(false)
    }
    if (proceed) {
      processDeletion()
      setProceed(false)
    }
  }, [proceed, folderName, props])

  useEffect(() => {
    loadPII()
  }, [])

  //If the popup to add the file disappeared then PII scan should be erased.
  useEffect(() => {
    setPIIScan({})
  }, [multiplePopup])

  //Hiding to debug
  useEffect(() => {
    const canDisplay = areChangesStored(piiScan)
    setDisplayPII(canDisplay)
  }, [piiScan])

  useEffect(() => {
    if (props?.ItemGUID && props?.currentInquiry) {
      getFiles(props.isInquiry)
    }
  }, [props?.ItemGUID, props?.currentInquiry])

  useEffect(() => {
    setCheckAllFiles(props?.checkAll)
    if (!props?.checkAll) {
      setModifyFiles([])
      setCheckedArr([])
    } else {
      setCheckedArr(['MPF/CSS', 'Team Members', 'Customer'])
      setModifyFiles(allFiles)
    }
  }, [allFiles, props?.checkAll])

  useEffect(() => {
    if (props?.reverseCheck && props?.checkAll) {
      setCheckedArr(['MPF/CSS', 'Team Members', 'Customer'])
      setModifyFiles(allFiles)
    }
  }, [props?.reverseCheck, props?.checkAll])

  useEffect(() => {
    props?.getSelectedFiles(modifyFiles, allFiles)
  }, [modifyFiles, allFiles])

  useEffect(() => {
    setPopupHeight(window.innerHeight - (offsetTopValue + 65))
    const popupWidthData = popupBtnRef.current ? popupBtnRef.current.offsetWidth : 0
    // setpopupwidth(popupWidthData)
    if (popupWidthData < xPositionValue) {
      xPositionValue = xPositionValue - popupWidthData
      setXPositionValueUpdate(xPositionValue)
    } else if (
      popupWidthData > offsetLeftValue &&
      popupWidthData < window.innerWidth - (offsetLeftValue + offsetWidthValue)
    ) {
      xPositionValue = offsetLeftValue
      setXPositionValueUpdate(xPositionValue)
    } else if (
      popupWidthData > offsetLeftValue &&
      popupWidthData > window.innerWidth - (offsetLeftValue + offsetWidthValue)
    ) {
      xPositionValue = 0
      setXPositionValueUpdate(xPositionValue)
    }
  }, [multiplePopup])

  return (
    <div className='d-flex flex-column card-body px-0 h-100 pt-0'>
      <div className=''>
        <div className='divcardinnerconnet'>
          <div className='pmgLinks'>
            <Accordions
              className='accordions'
              count='ms-1 badge bgcolor-primary border-radius3 px-1 font-10 whitetext'
              defaultActivekey='1'
              extras='p-0'
              extras1Class='d-flex ms-auto actionbtns'
              inputProps={{
                className: 'justify-content-start poppins-semibold font-13 px-0',
                contentclassName: 'max-h-200 overflow-auto',
              }}
              items={accordionItems}
              titleIcon='icon-open-folder pe-1 color-primary'
              titlecollapsedIcon='icon-close-folder pe-1 color-primary'
            />
          </div>
        </div>
      </div>
    </div>
  )
}
export default AccordionFiles
